import React, { ReactNode } from "react";
import { WagmiConfig, configureChains, createClient } from "wagmi";
import { localhost, mainnet, sepolia } from "wagmi/chains";
import { CoinbaseWalletConnector } from "wagmi/connectors/coinbaseWallet";
import { MetaMaskConnector } from "wagmi/connectors/metaMask";
import { WalletConnectConnector } from "wagmi/connectors/walletConnect";
import { infuraProvider } from "wagmi/providers/infura";
import { publicProvider } from "wagmi/providers/public";

import AccountProvider from "../modules/account/account.provider";
import { INFURA_PUBLIC_ID, SUPPORTED_ETH_NETWORKS } from "../modules/config";

export const supportedNetworkIds = SUPPORTED_ETH_NETWORKS;

const mapChainId = (chainId: number) =>
  chainId === 1
    ? mainnet
    : chainId === 11155111
    ? sepolia
    : chainId === 1337
    ? localhost
    : null;

const Web3Provider = ({ children }: { children: ReactNode }) => {
  const { chains, provider } = configureChains(
    SUPPORTED_ETH_NETWORKS.map(mapChainId),
    [infuraProvider({ apiKey: INFURA_PUBLIC_ID }), publicProvider()]
  );

  const wagmiClient = createClient({
    autoConnect: false,
    connectors: [
      new MetaMaskConnector({
        chains,
      }),
      new WalletConnectConnector({
        chains,
        options: {
          methods: ["eth_sendTransaction", "personal_sign"],
          projectId: "5d25f29a1678ed00627560b5543cf513",
          // @ts-expect-error - WalletConnect types are incorrect
          qrModalOptions: {
            themeVariables: {
              "--w3m-z-index": "200",
            },
          },
        },
      }),
      new CoinbaseWalletConnector({
        chains,
        options: {
          jsonRpcUrl: `https://mainnet.infura.io/v3/${INFURA_PUBLIC_ID}`,
          appName: "Flexa Capacity",
        },
      }),
    ],
    provider,
  });

  return (
    <WagmiConfig client={wagmiClient}>
      <AccountProvider>{children}</AccountProvider>
    </WagmiConfig>
  );
};

export default Web3Provider;
